var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7513 4.66667C8.7513 3.05584 7.44545 1.75 5.83464 1.75C4.22381 1.75 2.91797 3.05584 2.91797 4.66667C2.91797 6.27748 4.22381 7.58333 5.83464 7.58333C7.44545 7.58333 8.7513 6.27748 8.7513 4.66667Z",
    stroke: "#1E201C",
    strokeWidth: 0.875,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2096 12.2493V8.16602M8.16797 10.2077H12.2513",
    stroke: "#1E201C",
    strokeWidth: 0.875,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 11.6673C1.75 9.41215 3.57817 7.58398 5.83333 7.58398C6.70087 7.58398 7.50528 7.85453 8.16667 8.31589",
    stroke: "#1E201C",
    strokeWidth: 0.875,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteIcon);
export default __webpack_public_path__ + "static/media/invite-icon.4124108d033cac12f28ce3ab47432e35.svg";
export { ForwardRef as ReactComponent };